import { Phone, Instagram, MessageCircle } from "lucide-react";
import Logo from "../components/Logo";
import { NAV_LINKS, ORG } from "../data/content";
import { scrollToSection, openWhatsApp } from "../utils/scroll";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="grain relative overflow-hidden bg-[#08353D] pb-8 pt-16 sm:pt-20" data-testid="footer">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-[#D4AF37]/10 blur-3xl" />
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <Logo light size="lg" />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/65">
              Hope Giver is a community initiative spreading hope and creating positive change —
              through food, education, relief and the quiet power of people helping people.
            </p>
            <p className="mt-5 font-script text-2xl font-bold text-[#F3E096]">Made with hope. Built for change.</p>
          </div>

          <nav aria-label="Footer navigation">
            <h3 className="text-xs font-extrabold uppercase tracking-[0.24em] text-[#D4AF37]">Explore</h3>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    onClick={(e) => scrollToSection(e, l.href)}
                    data-testid={`footer-link-${l.href.replace("#", "")}`}
                    className="text-sm font-semibold text-white/70 transition-colors hover:text-[#F3E096]"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="text-xs font-extrabold uppercase tracking-[0.24em] text-[#D4AF37]">Reach Us</h3>
            <ul className="mt-5 space-y-3.5">
              <li>
                <a
                  href={ORG.phoneTel}
                  data-testid="footer-phone-link"
                  className="flex items-center gap-3 text-sm font-semibold text-white/70 transition-colors hover:text-[#F3E096]"
                >
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-[#F3E096]">
                    <Phone size={15} />
                  </span>
                  {ORG.phoneDisplay}
                </a>
              </li>
              <li>
                <a
                  href={ORG.instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram-link"
                  className="flex items-center gap-3 text-sm font-semibold text-white/70 transition-colors hover:text-[#F3E096]"
                >
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-[#F3E096]">
                    <Instagram size={15} />
                  </span>
                  {ORG.instagramHandle}
                </a>
              </li>
              <li>
                <button
                  onClick={() => openWhatsApp(ORG.whatsappNumber, "Namaste Hope Giver team!")}
                  data-testid="footer-whatsapp-button"
                  className="flex items-center gap-3 text-sm font-semibold text-white/70 transition-colors hover:text-[#F3E096]"
                >
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-[#F3E096]">
                    <MessageCircle size={15} />
                  </span>
                  WhatsApp us
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-7 sm:flex-row">
          <p className="text-xs text-white/50" data-testid="footer-copyright">
            © {year} Hope Giver. All rights reserved.
          </p>
          <p className="text-xs text-white/50">
            Made with hope. <span className="text-[#D4AF37]">Built for change.</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
